module.exports = __webpack_public_path__ + "img/email.e2d78d55.svg";